export function fire(target, eventType, detail) {
  switch (eventType) {
    case 'submit':
      eventType = 'turbo:submit-start';
      break;
  }

  if (typeof detail !== 'object' && !isIterable(detail)) {
    detail = [detail];
  }
  target.dispatchEvent(new CustomEvent(eventType, { detail, bubbles: true }));
}

function isIterable(obj) {
  if (obj == null) {
    return false;
  }

  return typeof obj[Symbol.iterator] === 'function';
}
